/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceResourceInventoryLookupRequest {
    getFixupPrototypeFunction() { return ServiceResourceInventoryLookupRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceResourceInventoryLookupRequest>): ServiceResourceInventoryLookupRequest {
        let obj = Object.assign(new ServiceResourceInventoryLookupRequest(), model);
        ServiceResourceInventoryLookupRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceResourceInventoryLookupRequest>): ServiceResourceInventoryLookupRequest {
        if (!model) return null;
        return ServiceResourceInventoryLookupRequest.newInstance(<ServiceResourceInventoryLookupRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceResourceInventoryLookupRequest) {
        if (!obj) return;

        models.ServiceResourceInventoryLookupRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceResourceInventoryLookupRequest): boolean {
        Object.setPrototypeOf(obj, ServiceResourceInventoryLookupRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of the resource
     */
    corestack_resource_ids: Array<string>;

}
